import Vue from 'vue';
import Vuex from 'vuex';
import { getMenuList, getSysInfo } from '@/api/main.js';
import chat from './modules/chat.js';
import createPersistedState from 'vuex-persistedstate';
import newChat from './modules/newChat.js';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        chat:chat,
        newChat:newChat
    },
    state: {

        menuList: [],
        // themeColor: '#3c8dbc',
        themeColor: '#ffffff',
        userInfo: {},
        sysInfo: {},
        productSpecificationId: '', // 商品规格id
        shopProductSpecifications: {}, // 商品规格
        productShowDialog: false 
    },
    mutations: {
        setUserInfo(state, payload) {
            state.userInfo = payload.data;
        },
        setTheme(state, theme) {
            state.themeColor = theme;
        },
        setMenuList(state, payload) {
            state.menuList = payload.data;
        },
        setSysInfo(state, payload) {
            state.sysInfo = payload.data;
        },
        setProductSpecificationId(state, payload) {
            state.productSpecificationId = payload;
        },
        setShopProductSpecifications(state, payload) {
            state.shopProductSpecifications = payload;
            
        }
      
    },
    actions: {
        getLeftMenuList({ commit }) {
            getMenuList().then((res) => {
                console.log(res);
                if (res.success) {
                    commit('setMenuList', { data: res.listMenu });
                }
            });
        },
        getSysInfo({ commit }){
            getSysInfo().then((res)=>{
                if(res.success){
                    commit('setSysInfo', { data: res.data });
                }
            })
        },
        getProductSpecificationId({ commit }){
            commit('setProductSpecificationId', { data: this.state.productSpecificationId });
        },
        getShopProductSpecifications({ commit }){
            commit('setShopProductSpecifications', { data: this.state.shopProductSpecifications });
        }
    },
    plugins: [
        createPersistedState({
            // 存储方式：localStorage、sessionStorage、cookies
            storage: window.localStorage,
            // 存储的 key 的key值
            key: 'store',
            paths: ['chat']

            // reducer(state) {
            //     // 要存储的数据：本项目采用es6扩展运算符的方式存储了state中所有的数据
            //     return state.sessions;
            // }
        })
    ]
});
